import { backupLang } from "../../../../data/admin";
import { emptys, langsCodes } from "../../../../data/main";
import { stdObject } from "../../../../data/types/stdObject";
import i18n from "../../../../locales/i18n";
import { sendData } from "../../../../services/sendData";
import { updateBackupLang } from "../updateBackupLang";

export const openLangInfo = async (
  mainData: stdObject,
  update: boolean = false,
  params: stdObject,
) => {
  const {
    windowValues,
    setMsg,
    setModalData,
    setWindowValues,
    closeMsg,
    logoutAction,
  } = params;
  if (update) {
    setMsg("loading");
    const finalLangs = Object.keys(windowValues.data).map((e: string) => {
      return { lang: e, text: windowValues.data[e].text.trim() };
    });
    const payloadSaveLang = {
      codes: [windowValues.code, windowValues.prefix],
      langs: finalLangs.filter((e: stdObject) => e.text !== ""),
    };
    const responseSaveLang: stdObject = await sendData({
      endPoint: "saveLang",
      payload: payloadSaveLang,
      logoutAction,
    });
    console.log("responseSaveLang", responseSaveLang);
    if (responseSaveLang.success && responseSaveLang.status) {
      closeMsg();
      finalLangs.forEach((e: stdObject) => {
        const code = `${windowValues.prefix}.${windowValues.code}`;
        if (i18n.exists(code)) {
          updateBackupLang(
            e.lang,
            code,
            i18n.getResource(langsCodes[e.lang], "translation", code),
          );

          const newText =
            emptys.includes(e.text) && backupLang[langsCodes[e.lang]][code]
              ? backupLang[langsCodes[e.lang]][code]
              : e.text;
          i18n.addResource(langsCodes[e.lang], "translation", code, newText);
        }
      });
    } else {
      setMsg("error");
    }
  } else {
    const { code, prefix, name, langs } = mainData;
    let { data } = mainData;
    data = data.reduce((acc: stdObject, curr: stdObject) => {
      acc[curr.lang] = curr;
      return acc;
    }, {});
    langs.forEach((e: [string, string]) => {
      if (!(e[0] in data)) {
        data[e[0]] = { text: "" };
      }
    });
    setMsg("langModal");
    setWindowValues({ code, prefix, data });
    setModalData({ title: name, inputs: langs });
  }
};
